import { Button } from "../../components/Button/Button";
import { Dialog } from "../../components/Dialog/Dialog";
import type { UserRow } from "../../lib/api";
import { fullName } from "../../lib/users";

interface ConfirmDeleteDialogProps {
  open: boolean;
  user: UserRow | null;
  onClose: () => void;
  onConfirm: () => void;
  submitting?: boolean;
}

export function ConfirmDeleteDialog({
  open,
  user,
  onClose,
  onConfirm,
  submitting,
}: ConfirmDeleteDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Apagar utilizador"
      size="sm"
      footer={
        <>
          <Button variant="ghost" size="md" onClick={onClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button variant="primary" size="md" onClick={onConfirm} disabled={submitting}>
            {submitting ? "A apagar…" : "Apagar"}
          </Button>
        </>
      }
    >
      <p style={{ fontSize: 14, lineHeight: 1.5 }}>
        Tem a certeza que pretende apagar o utilizador{" "}
        <strong>{user ? fullName(user) : ""}</strong>?
      </p>
      <p style={{ fontSize: 13, color: "#6e6e6e", marginTop: 8 }}>
        Esta acção é irreversível.
      </p>
    </Dialog>
  );
}
